import { SET_LEVEL_INFO, SET_UNITS } from '../actions/action_types';

const initialState = {
  hirarchy: {
    type: {},
    level: {},
    breadCrumbName: '',
    tabsList: [],
    units: {},
  },
};

export const HirarchyReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_LEVEL_INFO:
      // eslint-disable-next-line no-case-declarations
      const { type, level, breadCrumbName, tabsList } = action.payload;
      return {
        ...state,
        hirarchy: {
          ...state.hirarchy,
          type,
          level,
          breadCrumbName,
          tabsList,
        },
      };
    case SET_UNITS:
      return {
        ...state,
        hirarchy: {
          ...state.hirarchy,
          units: action.payload,
        },
      };
    default:
      return state;
  }
};
